// extracted by mini-css-extract-plugin
export var borderRadius = "_bb-4";
export var large = "_bb-3";
export var logoContainer = "_bb-0";
export var nameLogo = "_bb-2";
export var small = "_bb-1";